import React from 'react'

export default function Footer() {
   return (
      <footer className='container-fluid p-3 d-flex justify-content-center align-items-center gap-2  shadow-lg'>
         <p className='m-0'>all right reserved </p> <a href="https://yosefus-portfolio.netlify.app/">visit me</a>
      </footer>
   )
}
